export class CustomizationStore {
    constructor() {
        this.mainColor = "#9653A2";
        this.title = "1 compra = 1 doação";
    }

    mainColor: string;
    secondaryColor: string;
    position: string;
    title: string;
    polenText: string;
    polenMessageText: string;
    polenSecondText: string;
    ongSelectedText: string;
    thankYouText: string;
    
    mainIcon: string;
}
